<template>
  <div class="footer_container">
    <footer>
      <div class="about" v-for="(obj,i) in bottomList" :key="i">
        <h6>{{obj.title}}</h6>
        <div class="span_all">
          <a :href="par.href" :target="par.target" v-for="(par,index) in obj.data" :key="index">
            <span>{{par.value}}</span>
          </a>
        </div>
      </div>
    </footer>
    <div class="copyright">
      <div class="copyright_info">
        <a href="/archive/course">课程存档</a>
        课程内容版权均归<a href="/">成功之道（北京）教育科技股份有限公司</a>
        <a href="https://beian.miit.gov.cn" target="_blank">京ICP备15037598号-4</a>
        <div class="powered_by"><a href="/"> Powered by 成功之道（北京）教育科技股份有限公司</a></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPcBottom } from '@/util/api/modules/home.js'

export default {
  name: 'ttxl-footer',
  data () {
    return {
      bottomList: {}
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      getPcBottom().then(data => {
        this.bottomList = data
      })
    }
  }
}
</script>

<style lang="stylus">
footer
  width 1180px
  height 238px
  margin 0 auto
  background rgba(255,255,255,1)
  display flex
  justify-content space-between
  .about
    padding-top 40px
    h6
      margin 0
      font-size 18px
      font-family MicrosoftYaHei
      color rgba(51,51,51,1)
      line-height 18px
    .span_all
      padding-top 20px
      a
        display block
        span
          font-size 12px
          font-family MicrosoftYaHei
          color rgba(102,102,102,1)
          line-height 16px
          display inline-block
          padding-bottom 10px
.copyright
  background: #4a4d55;
  text-align: center;
  font-size: 12px;
  color: #a2a3a6;
  padding-top: 2px;
  padding-bottom: 11px;
  .copyright_info
    padding-top 10px;
    margin-bottom 10px
    a
      font-size: 12px;
      color: #a2a3a6;
      text-decoration: none;
    .powered_by
      display: inline-block
      padding-left 23px
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue